import { forwardRef, useState } from "react";

const CustomInput = forwardRef(
  (
    {
      placeholder,
      type = "text",
      width = "",
      height = "52px",
      isTextarea = false,
      required = false,
      value = "",
      onChange,
      disabled = false,
      error = "",
      classNames = "",
      onBlur,
      onKeyDown,
      autoComplete = "off",
      rows = 4,
    },
    ref
  ) => {
    const [isFocused, setIsFocused] = useState(false);
    const hasError = Boolean(error);

    return (
      <div className="relative w-full" style={{ maxWidth: width }}>
        {!isFocused && !value && placeholder && (
          <div
            className="absolute left-3 pointer-events-none text-gray-400"
            style={{
              top: isTextarea ? "14px" : `calc(${height} / 2)`,
              transform: isTextarea ? "none" : "translateY(-50%)",
            }}
          >
            {placeholder}
            {required && <span className="text-red-500">*</span>}
          </div>
        )}

        {!isTextarea ? (
          <input
            ref={ref}
            type={type}
            name="no-autofill"
            autoComplete={autoComplete}
            value={value || ""}
            disabled={disabled}
            onChange={(e) => onChange?.(e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={(e) => {
              setIsFocused(false);
              onBlur?.(e);
            }}
            onKeyDown={onKeyDown}
            required={required}
            style={{ height }}
            className={`border ${hasError ? "border-red-500" : "border-gray-300"
              } rounded-md py-3 px-4 w-full focus:outline-blue-500 text-[#454545] ${disabled ? "opacity-50 cursor-default bg-gray-50" : ""
              } ${classNames}`}
          />
        ) : (
          <textarea
            ref={ref}
            name="no-autofill"
            autoComplete={autoComplete}
            value={value || ""}
            disabled={disabled}
            onChange={(e) => onChange?.(e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={(e) => {
              setIsFocused(false);
              onBlur?.(e);
            }}
            required={required}
            rows={rows}
            className={`border ${hasError ? "border-red-500" : "border-gray-300"
              } rounded-md py-3 px-4 w-full focus:outline-blue-500 text-[#454545] resize-none ${disabled ? "opacity-50 cursor-default bg-gray-50" : ""
              } ${classNames}`}
          />
        )}

        {hasError && <div className="text-red-500 text-sm mt-1">{error}</div>}
      </div>
    );
  }
);

export default CustomInput;
